module.exports = __webpack_public_path__ + "img/compenstate_popup_ bg.2dfe84fd.png";